<template>
  <div>
    <div class="header">
      <img class="logo" src="@/assets/guarapuava.png" />
      <div class="clock">{{clock}}</div>
      <div class="stop-name">{{panelConfig.panelHeader}}</div>
    </div>
    <DeparturesTable :panelConfig="panelConfig" :stopData="stopData"></DeparturesTable>
  </div>
</template>

<script>
import DeparturesTable from './DeparturesTable';

export default {
  components: {
    DeparturesTable
  },
  props: ['panelConfig', 'stopData', 'clock'],
};
</script>

<style lang="scss">
.header {
  padding: 1em .6em;
  background: linear-gradient(0deg, #e7b900 0%, #f3d600 100%);
  border-bottom: .1em solid #00000045;
}
.logo {
  height: 2.6em;
  margin-top: -.7em;
}
.clock {
  float: right;
}
.stop-name {
  text-align: center;
  margin-top: .5em;
}

table {
  th {
    background: #164e7f !important;
  }
}

@media only screen and (min-width: 600px) {
  .header {
    height: 3.25em;
  }
  .clock {
    font-size: 2em;
    margin-top: -.35em;
  }
  .stop-name {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 3.25em;
    padding: 0 10em;
    margin-top: 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>